import { ProgressProps } from 'core/progress/progress.props';

export const ProgressPresets: Partial<ProgressProps> = {
  background: 'lightGrey',
  color: 'black',
  width: '100%',
};
